var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5076 20.792H4.34319C5.58604 19.9167 6.40067 18.4703 6.40067 16.837V12.003H10.4149C10.6576 12.003 10.8542 11.8064 10.8542 11.5637C10.8542 11.3206 10.6577 11.1242 10.4149 11.1242H6.40067V6.29018C6.40067 3.62492 8.56881 1.45617 11.2347 1.45617C13.8998 1.45617 16.0687 3.62476 16.0687 6.29018C16.0687 6.53295 16.2652 6.72965 16.508 6.72965C16.7511 6.72965 16.9475 6.53297 16.9475 6.29018C16.9475 3.14044 14.3846 0.577148 11.2345 0.577148C8.08472 0.577148 5.52143 3.14002 5.52143 6.29018V11.1242H1.62561C1.38284 11.1242 1.18614 11.3207 1.18614 11.5637C1.18614 11.8064 1.38268 12.003 1.62561 12.003H5.52143V16.837C5.52143 19.0177 3.7474 20.792 1.56642 20.792C1.32365 20.792 1.12695 20.9885 1.12695 21.2313C1.12695 21.4744 1.32348 21.6708 1.56642 21.6708H16.5074C16.7505 21.6708 16.9469 21.4742 16.9469 21.2313C16.9469 20.9887 16.7504 20.7921 16.5074 20.7921L16.5076 20.792Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.43359,
    y: 1.01074,
    width: 27.5774,
    height: 0.672619,
    transform: "rotate(45 1.43359 1.01074)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPound);
export default __webpack_public_path__ + "static/media/Pound.65e9f0e477ab8b5cf0e802c6158ccbd8.svg";
export { ForwardRef as ReactComponent };